import { render, staticRenderFns } from "./ProjTaskEdit.vue?vue&type=template&id=556c94f8"
import script from "./ProjTaskEdit.vue?vue&type=script&lang=js"
export * from "./ProjTaskEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports